import React__default, { memo, useRef } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/Slider.scss';
import { SliderContext } from './context.js';
import { fractionFromPos, clamp, roundByStep, reverseFraction } from './utils.js';

var _excluded = ["minValue", "maxValue", "reverse", "onClick", "orientation", "stepSize", "children", "variant"];
var Track = /*#__PURE__*/memo(function (_ref) {
  var _extends2, _cn, _cn2, _cn3;
  var _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
    maxValue = _ref.maxValue,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    onClick = _ref.onClick,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? "horizontal" : _ref$orientation,
    _ref$stepSize = _ref.stepSize,
    stepSize = _ref$stepSize === void 0 ? 0.01 : _ref$stepSize,
    children = _ref.children,
    variant = _ref.variant,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var myClamp = function myClamp(value) {
    return clamp(minValue, maxValue, value);
  };
  var myRoundByStep = function myRoundByStep(value) {
    return roundByStep(value, stepSize);
  };
  var valueToPercent = function valueToPercent(value) {
    return Math.abs((value - minValue) / (maxValue - minValue)) * 100;
  };
  var coordsToValue = function coordsToValue(_ref2) {
    var x = _ref2.x,
      y = _ref2.y;
    if (!element.current) {
      return null;
    }
    var pos = orientation === "horizontal" ? x : y;
    var rect = element.current.getBoundingClientRect();
    var fraction = fractionFromPos(orientation, rect, pos);
    return myClamp(minValue + myRoundByStep((reverse ? reverseFraction(fraction) : fraction) * (maxValue - minValue)));
  };
  var context = {
    orientation: orientation,
    reverse: reverse,
    clamp: myClamp,
    stepSize: stepSize,
    roundByStep: myRoundByStep,
    valueToPercent: valueToPercent,
    coordsToValue: coordsToValue,
    minValue: minValue,
    maxValue: maxValue
  };
  var element = useRef(null);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, restProps, {
    ref: element,
    style: _extends((_extends2 = {}, _extends2[orientation === "horizontal" ? "width" : "height"] = "100%", _extends2), restProps.style),
    className: cn(styles.block, [styles["block__" + orientation]], (_cn = {}, _cn[styles.block__reverse] = reverse, _cn), (_cn2 = {}, _cn2[styles.hasVariant] = Boolean(variant), _cn2), (_cn3 = {}, _cn3[styles[variant]] = Boolean(variant), _cn3)),
    onMouseDown: function onMouseDown(_ref3) {
      var pageX = _ref3.pageX,
        pageY = _ref3.pageY;
      if (onClick) {
        var _value = coordsToValue({
          x: pageX,
          y: pageY
        });
        if (_value !== null) {
          onClick(_value);
        }
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.track
  }), /*#__PURE__*/React__default.createElement(SliderContext.Provider, {
    value: context
  }, children));
});

export { Track };
//# sourceMappingURL=track.js.map
